import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, DatePicker, Icon, notification, Divider } from "antd";
import axios from "axios";
import moment from "moment";
import SectionCard from "../../components/SectionCard";
import SectionDivider from "../../components/SectionDivider";

const { TextArea } = Input;

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({ message, description });
};

const parseObject = (value, fallback = {}) => {
    if (!value) return fallback;
    if (typeof value === "object") return value;

    try {
        const parsed = JSON.parse(value);
        return typeof parsed === "object" ? parsed : fallback;
    } catch {
        return fallback;
    }
};

const DrawerRelatorioIndividual = ({ id, visible, atualizarListagem, onClose, form }) => {
    const estadoInicial = {
        id: undefined,
        id_disciplina: undefined,
        tipo: "relatorio_bimestral_educacao_infantil",

        apresentacao: {
            aluno: "",
            turma: "",
            professora: "",
            periodo: ""
        },

        participacao: "",
        desenvolvimento_cognitivo: "",
        linguagem_comunicacao: "",
        movimento_motor: "",
        socializacao: "",
        consideracoes_finais: ""
    };

    const [registo, setRegisto] = useState(estadoInicial);
    const [isLoading, setIsLoading] = useState(false);

    const { getFieldDecorator } = form;

    const handleSubmit = e => {
        e.preventDefault();

        form.validateFields((err, values) => {
            if (!err) {
                if (id) alterar(values);
                else adicionar(values);
            }
        });
    };

    const carregarDetalhe = id => {
        setIsLoading(true);

        axios
            .get("/api/relatorio-individual/carregar-relatorio-individual", { params: { id } })
            .then(res => {
                const data = res.data;

                const apresentacao = parseObject(data.apresentacao, {});

                setRegisto({
                    ...data,

                    apresentacao: {
                        aluno: apresentacao.aluno || "",
                        turma: apresentacao.turma || "",
                        professora: apresentacao.professora || "",
                        periodo: apresentacao.periodo || ""
                    },

                    participacao: data.participacao || "",
                    desenvolvimento_cognitivo: data.desenvolvimento_cognitivo || "",
                    linguagem_comunicacao: data.linguagem_comunicacao || "",
                    movimento_motor: data.movimento_motor || "",
                    socializacao: data.socializacao || "",
                    consideracoes_finais: data.consideracoes_finais || ""
                });
            })
            .finally(() => setIsLoading(false));
    };

    const carregarDadosAlunoEnsinoEspecial = () => {
        axios({
            method: "get",
            url: "/api/estudo-caso/carregar-informacoes-ensino-especial",
            params: {
                disciplinaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                const { aluno, turma } = response.data;

                setRegisto(prevState => ({
                    ...prevState,
                    apresentacao: {
                        ...prevState.apresentacao,
                        aluno: aluno?.nome || "",
                        turma: turma?.nome || ""
                    }
                }));
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Erro ao carregar dados.");
            });
    };

    const adicionar = values => {
        setIsLoading(true);

        let item = new FormData();
        item.append("id", id);
        item.append("id_disciplina", localStorage.getItem("codigo_curso"));
        item.append("tipo", "relatorio_bimestral_educacao_infantil");
        item.append(
            "apresentacao",
            JSON.stringify({
                aluno: values.apresentacao_aluno,
                turma: values.apresentacao_turma,
                professora: values.apresentacao_professora,
                periodo: values.apresentacao_periodo
            })
        );
        item.append("participacao", values.participacao);
        item.append("desenvolvimento_cognitivo", values.desenvolvimento_cognitivo);
        item.append("linguagem_comunicacao", values.linguagem_comunicacao);
        item.append("movimento_motor", values.movimento_motor);
        item.append("socializacao", values.socializacao);
        item.append("consideracoes_finais", values.consideracoes_finais);

        axios({
            method: "post",
            url: "/api/relatorio-individual/adicionar-relatorio-individual",
            data: item
        })
            .then(response => {
                openNotificationWithIcon("success", "Sucesso", "Relatório criado.");
                atualizarListagem();
                handleClose();
                setIsLoading(false);
            })
            .catch(error => {
                setIsLoading(false);
            });
    };

    const alterar = values => {
        setIsLoading(true);

        let item = new FormData();
        item.append("id", id);
        item.append("id_disciplina", localStorage.getItem("codigo_curso"));
        item.append("tipo", "relatorio_bimestral_educacao_infantil");
        item.append(
            "apresentacao",
            JSON.stringify({
                aluno: values.apresentacao_aluno,
                turma: values.apresentacao_turma,
                professora: values.apresentacao_professora,
                periodo: values.apresentacao_periodo
            })
        );
        item.append("participacao", values.participacao);
        item.append("desenvolvimento_cognitivo", values.desenvolvimento_cognitivo);
        item.append("linguagem_comunicacao", values.linguagem_comunicacao);
        item.append("movimento_motor", values.movimento_motor);
        item.append("socializacao", values.socializacao);
        item.append("consideracoes_finais", values.consideracoes_finais);

        axios({
            method: "put",
            url: "/api/relatorio-individual/alterar-relatorio-individual",
            data: item
        })
            .then(response => {
                openNotificationWithIcon("success", "Sucesso", "Relatório alterado.");
                atualizarListagem();
                handleClose();
                setIsLoading(false);
            })
            .catch(error => {
                setIsLoading(false);
            });
    };

    const handleClose = () => {
        onClose();
        limparCampos();
    };

    const limparCampos = () => {
        form.resetFields();
        setRegisto(estadoInicial);
    };

    useEffect(() => {
        if (visible && id) carregarDetalhe(id);

        if (visible && !id) {
            carregarDadosAlunoEnsinoEspecial();
        }
    }, [visible, id]);

    return (
        <Drawer
            className="drawer-adicionar-evento drawer-add-cursos"
            width={720}
            onClose={handleClose}
            visible={visible}
            maskClosable={false}
        >
            <div className="bloco-info">
                <Form className="form-categorias" layout="horizontal" onSubmit={handleSubmit}>
                    <SectionCard title="Apresentação">
                        <Form.Item label="Aluno">
                            {getFieldDecorator("apresentacao_aluno", {
                                initialValue: registo.apresentacao.aluno,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Turma">
                            {getFieldDecorator("apresentacao_turma", {
                                initialValue: registo.apresentacao.turma,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Professora">
                            {getFieldDecorator("apresentacao_professora", {
                                initialValue: registo.apresentacao.professora,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Período">
                            {getFieldDecorator("apresentacao_periodo", {
                                initialValue: registo.apresentacao.periodo,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>
                    </SectionCard>

                    <SectionCard title="1. Participação">
                        <Form.Item>
                            {getFieldDecorator("participacao", {
                                initialValue: registo.participacao
                            })(<TextArea rows={5} style={{ minHeight: 100 }} />)}
                        </Form.Item>
                    </SectionCard>

                    <SectionCard title="2. Desenvolvimento Cognitivo">
                        <Form.Item>
                            {getFieldDecorator("desenvolvimento_cognitivo", {
                                initialValue: registo.desenvolvimento_cognitivo
                            })(<TextArea rows={5} style={{ minHeight: 100 }} />)}
                        </Form.Item>
                    </SectionCard>

                    <SectionCard title="3. Linguagem e Comunicação">
                        <Form.Item>
                            {getFieldDecorator("linguagem_comunicacao", {
                                initialValue: registo.linguagem_comunicacao
                            })(<TextArea rows={5} style={{ minHeight: 100 }} />)}
                        </Form.Item>
                    </SectionCard>

                    <SectionCard title="4. Desenvolvimento Motor">
                        <Form.Item>
                            {getFieldDecorator("movimento_motor", {
                                initialValue: registo.movimento_motor
                            })(<TextArea rows={5} style={{ minHeight: 100 }} />)}
                        </Form.Item>
                    </SectionCard>

                    <SectionCard title="5. Socialização">
                        <Form.Item>
                            {getFieldDecorator("socializacao", {
                                initialValue: registo.socializacao
                            })(<TextArea rows={5} style={{ minHeight: 100 }} />)}
                        </Form.Item>
                    </SectionCard>

                    <SectionCard title="6. Considerações Finais">
                        <Form.Item>
                            {getFieldDecorator("consideracoes_finais", {
                                initialValue: registo.consideracoes_finais
                            })(<TextArea rows={5} style={{ minHeight: 100 }} />)}
                        </Form.Item>
                    </SectionCard>

                    <div className="ant-drawer-footer">
                        <button
                            type="button"
                            className="botao-secundario"
                            onClick={handleClose}
                            style={{ marginRight: 20, display: "inline-block" }}
                        >
                            Cancelar
                        </button>

                        <button type="submit" className="botao-principal" disabled={isLoading}>
                            {isLoading && <Icon type="loading" />}
                            Salvar
                        </button>
                    </div>
                </Form>
            </div>
        </Drawer>
    );
};

export default Form.create({ name: "form-relatorio-individual" })(DrawerRelatorioIndividual);
